module.exports = __webpack_public_path__ + "media/images/logo-f6d99269d5833dce4c95531ae6732d6f.png";